import * as React from "react";
import * as ReactDOM from "react-dom";

/**
 * This component allows you to render content outside main app component DOM tree
 *
 * @example
 *   <ModalPortal>
 *     <Modal>Hello World!</Modal>
 *   </ModalPortal>
 */

interface IProps {
  children: React.ReactNode;
}

export class ModalPortal extends React.PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);

    this.modalContainer = document.createElement("div");
    this.modalContainer.className = "modal-portal-container";
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    document.querySelector("body").appendChild(this.modalContainer);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentWillUnmount() {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    document.querySelector("body").removeChild(this.modalContainer);
  }

  modalContainer: HTMLDivElement;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return ReactDOM.createPortal(this.props.children, this.modalContainer);
  }
}
